import { Component } from "@angular/core";
import { SEND_TYPES } from "app/app-config";
import {
  Plan,
  PlanConsumption,
} from "app/main/pages/customers/plan-consumption/plan-consumption.interface";
import { AuthenticationService } from "app/main/services/authentication.service";
import { PlanConsumptionService } from "app/main/services/plan-consumption.service";
import { PlanService } from "app/main/services/plan.service";
import { UserService } from "app/main/services/user.service";
import { take } from "rxjs/operators";

export const PRODUCT_STYLE = {
  [SEND_TYPES.SMS]: {
    icon: "fa-solid fa-comment-sms",
    color: "info",
    bg: "#E1E5F0",
  },
  [SEND_TYPES.WHATSAPP]: {
    icon: "fa-brands fa-whatsapp",
    color: "success",
    bg: "#E1EEE2",
  },
  [SEND_TYPES.EMAIL]: {
    icon: "fa-regular fa-bell",
    color: "primary",
    bg: "#DFEDF0",
  },
  [SEND_TYPES.PUSH]: {
    icon: "fa-regular fa-envelope",
    color: "secondary",
    bg: "#F2E7DF",
  },
};

@Component({
  selector: "app-plan-consumption",
  templateUrl: "./plan-consumption.component.html",
  styleUrls: ["./plan-consumption.component.scss"],
})
export class PlanConsumptionComponent {
  productStyle = PRODUCT_STYLE;
  planConsumptionList: PlanConsumption[] = [];
  currentPlan: Plan = null;
  remainingUnits: any = {};
  limits: any = {};
  consumed: any = {};

  constructor(
    private readonly planConsumption: PlanConsumptionService,
    private readonly planService: PlanService,
    private userService: UserService,
    private authService: AuthenticationService
  ) {
    this.getCurrentConsumption();
    this.getCurrentPlan();
  }

  getCurrentPlan() {
    this.planService
      .getMyPlan()
      .pipe(take(1))
      .subscribe((res) => {
        this.currentPlan = res;
      });
  }

  getCurrentConsumption() {
    this.planConsumption
      .getPlanConsumptionByCompanyId()
      .pipe(take(1))
      .subscribe((res) => {
        console.log("Modal Consumption: ", res);
        this.planConsumptionList = res;
        this.userService
        .getLimits()
        .pipe(take(1))
        .subscribe((res) => {
          console.log("limits", res);
          res.limits.forEach((l) => {
            const available = res.consumptions.find((c) =>{
              return c.productId == l.product_id;
            });
            this.limits[l.product_id] = l.message_limit;
            this.consumed[l.product_id] = (available?.totalMessagesConsumed || 0);
            this.remainingUnits[l.product_id] = l.message_limit - (available?.totalMessagesConsumed || 0);
          });
        });
      });
  }
}
